// extracted by mini-css-extract-plugin
module.exports = {"fontTheme":"wsj_fontTheme__LguxE"};